import { PresentableCompayStyle } from '~/presenters/CompanyStylePresenter';
import { CompanyInfo, CompanyStyle } from '~/types/CompanyInfo';

export function createCompanyStyleFromTheme(theme: string): CompanyStyle {
  switch (theme) {
    case 'purple':
      return {
        primaryColor: '#9211AF',
        hoverColor: '#AC37C6',
        activeColor: '#7B1192',
        gradientStartColor: '#9211AF',
        gradientEndColor: '#8A10A5',
      };
    case 'orange':
      return {
        primaryColor: '#B64F16',
        hoverColor: '#DF7337',
        activeColor: '#6D3500',
        gradientStartColor: '#B64F16',
        gradientEndColor: '#B14815',
      };
    case 'green':
      return {
        primaryColor: '#0F995E',
        hoverColor: '#24B476',
        activeColor: '#087546',
        gradientStartColor: '#0F995E',
        gradientEndColor: '#0E9058',
      };
    case 'black':
      return {
        primaryColor: '#232231',
        hoverColor: '#4F4E67',
        activeColor: '#0D0C15',
        gradientStartColor: '#232231',
        gradientEndColor: '#1F1E2C',
      };
    default: //Blue
      return {
        primaryColor: '#0769FF',
        hoverColor: '#2B7FFF',
        activeColor: '#0054D4',
        gradientStartColor: '#0769FF',
        gradientEndColor: '#0065FF',
      };
  }
}
export function presentCompanyInfo(companyInfo: CompanyInfo): PresentableCompayStyle {
  return {
    name: companyInfo.name || '',
    logo: companyInfo.logo ? `/tenants/api${companyInfo.logo}` : '',
    primaryColor: companyInfo.style.primaryColor,
    hoverColor: companyInfo.style.hoverColor,
    activeColor: companyInfo.style.activeColor,
    gradientStartColor: companyInfo.style.gradientStartColor,
    gradientEndColor: companyInfo.style.gradientEndColor,
    companyId: companyInfo.id,
  };
}
